import ApiService from '../../../../../services/ApiService'

export default {
  data: () => ({
    apiService: new ApiService(),
    maxUsers: 1,
    isSSO: false,
    unidades: [],
    generatedLink: '',
    links: [],
    unidadeLoading: false,
    institutionLoading: false,
    institutionId: 0,
    institutions: [],
    userLogged: {},
    generateLinkDialog: false,
    currentPage: 1,
    totalPages: 1,
    pageSize: 10,
    historyModal: false,
  }),
  async created() {
    this.userLogged = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.institutionId = this.institution.id

    this.unidadeId =
      this.institution.userType > 2 && this.institution.userType != 8
        ? this.userLogged.unidadeId
        : 0

    this.getInstitutions()
    this.searchUnidades()
    this.fetchLinks()
  },

  methods: {
    async getInstitutions() {
      this.institutionLoading = true

      await this.apiService.get('institution/list').then((response) => {
        this.institutions = response.content
        this.institutionLoading = false
      })
    },

    async searchUnidades() {
      this.unidadeLoading = true

      await this.apiService
        .get(`unidade/list/${this.institutionId}`)
        .then((response) => {
          this.unidades = response.content
          this.unidadeLoading = false
        })
    },

    copyToClipboard() {
      const link = this.generatedLink
      navigator.clipboard.writeText(link)
      this.$toast.success('Link copiado! É só compartilhar 🔗')
    },
    copyHistoryLinkToClipboard(link) {
      navigator.clipboard.writeText(link)
      this.$toast.success('Link copiado! É só compartilhar 🔗')
    },
    async fetchLinks() {
      await this.apiService
        .post('User/links/paginate', {
          institutionId: this.institutionId,
          page: this.currentPage,
          pageSize: this.pageSize,
        })
        .then((response) => {
          if (response.statusCode === 200) {
            this.links = response.content.links.data
            this.totalPages = response.content.totalPages
          }
        })
        .catch((error) => {
          this.$toast.error(
            `Erro ao mostrar links antigos: ${error.message || error}`
          )
        })
    },

    async generateLink() {
      await this.apiService
        .post('User/generate-registration-link', {
          creatoruserId: this.userLogged.id,
          maxRegistrations: this.maxUsers,
          institutionId: this.institutionId,
          unidadeId: this.unidadeId,
          isSSO: this.isSSO,
        })
        .then((response) => {
          if (response.statusCode === 200) {
            const linkId = response.content
            const baseUrl = window.location.origin

            this.generatedLink = `${baseUrl}/auth/register-client-link?id=${linkId}`
            this.fetchLinks()
          }
        })
        .catch((error) => {
          this.$toast.error(`Erro ao gerar link: ${error.message || error}`)
        })
    },

    submitForm() {
      const form = this.$refs.form
      if (form.validate()) {
        this.generateLink()
      } else {
      }
    },

    closeGenerateLinkDialog() {
      this.generateLinkDialog = false
    },

    getFullLink(id) {
      return `${window.location.origin}/auth/register-client-link?id=${id}`
    },
    openHistoryModal() {
      this.historyModal = true
    },

    closeHistoryModal() {
      this.historyModal = false
    },
    isActive(link) {
      const currentDate = new Date()
      const expirationDate = new Date(link.expirationDate)

      const isDateValid = currentDate.getTime() <= expirationDate.getTime()
      const isUnderLimit = link.currentRegistrations < link.maxRegistrations

      return isDateValid && isUnderLimit
    },
  },
}
